/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 21/11/2013
 * Time: 19:05
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').factory('Image_Resource', ["$resource", "$location", function ($resource, $location) {
    var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/images/:key', {}, {
        query: {method: 'GET', isArray: true},
        get: {method: 'GET'}
    });
}]);

angular.module('FlexyBeautyApp.services').factory('Image', ["Image_Resource", function (Image_Resource) {

    var Image = function (resource) {
        this.id = null;
        this.fileName = null;
        this.type = null;
        this.label = null;
        this.keyWords = null;
        this.urlHD = null;
        this.url = null;
        this.urlPreview = null;
        this.size = null;
        this.hasHD = false;
        this.status = false;
        if (resource !== undefined && resource != null) {
            this.id = resource.id;
            this.fileName = resource.fileName;
            this.type = resource.type;
            this.label = resource.label;
            this.keyWords = resource.keyWords;
            this.status = resource.status;
            if (resource.url)
                this.url = resource.url.replace("http:", "");
            if (resource.urlHD) {
                this.urlHD = resource.urlHD.replace("http:", "");
                this.hasHD = true;
            } else
                this.urlHD = this.url;
            if (resource.urlPreview)
                this.urlPreview = resource.urlPreview.replace("http:", "");
            this.size = resource.size;
        }
    }

    Image.prototype.setId = function (id) {
        this.id = id;
    }

    Image.prototype.getObjectResource = function () {
        var rsImage = new Image_Resource();
        rsImage.id = this.id;
        rsImage.fileName = this.fileName;
        rsImage.type = this.type;
        rsImage.label = this.label;
        rsImage.keyWords = this.keyWords;
        rsImage.status = this.status;

        return rsImage;
    }
    return Image;
}]);
angular.module('FlexyBeautyApp.services').factory('ImageSrv', ["Image_Resource", "Image", "ImageData", "$log", "ServerSrv",
    function (Image_Resource, Image, ImageData, $log, ServerSrv) {
        var imageSrv = {};

        imageSrv.query = function (successFunction, errorFunction) {
            Image_Resource.query(
                {}, //params
                function (data) {   //success
                    ImageData.clear();
                    for (var i = 0; i < data.length; i++)
                        ImageData.add(new Image(data[i]));
                    if (successFunction !== undefined)
                        successFunction(ImageData.images.sort((image1, image2) => image1.label - image2.label));
                },
                function (data) {
                    $log.error(data);
                    if (errorFunction !== undefined)
                        errorFunction(data);
                });
        }

        imageSrv.save = function (image, successFunction, errorFunction) {
            ServerSrv.startSavingProcess(imageSrv.saveSync, image, successFunction, errorFunction);
        };

        imageSrv.saveSync = function (image, successFunction, errorFunction) {
            var ImageRes = image.getObjectResource();
            ImageRes.$save({},
                function (data) {
                    try {
                        image.setId(data.id);
                        if (successFunction != undefined)
                            successFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    } finally {
                        ServerSrv.endSavingProcess(false, (data ? data.status : null), (data && data.data ? data.data.errorCode : null));
                    }
                }
            );
        };

        return imageSrv;
    }]);
angular.module('FlexyBeautyApp.services').factory('ImageData', function () {
    let imageData = {images: []};
    imageData.getById = function (imageId) {
        for (var i = 0; i < this.images.length; i++)
            if (this.images[i].id == imageId)
                return this.images[i];
        return null;
    }
    imageData.add = function (image) {
        this.images.push(image);
    }
    imageData.remove = function (image) {
        var index = this.images.indexOf(image);
        if (index != -1)
            this.images.splice(index, 1);
    }
    imageData.clear = function () {
        this.images = [];
    }
    imageData.getActiveList = function (type) {
        if (type === undefined)
            return this.images;
        var images = [];
        for (var i = 0; i < this.images.length; i++)
            if (this.images[i].type == type || (this.images[i].type == null && type == ""))
                images.push(this.images[i]);
        return images.sort((image1, image2) => image1.label - image2.label);
    }

    imageData.getFilteredImages = function () {
        var imagesF = [];
        if (this.getActiveList("")) {
            for (var i = 0; i < this.getActiveList("").length; i++)
                if (this.getActiveList("")[i].status != 'NotActivated') {
                    imagesF.push(this.getActiveList("")[i]);
                }
        }
        return imagesF;
    };
    return imageData;

});



// WEBPACK FOOTER //
// ./js/services/modelsViews/Image.js